import React, { useState } from 'react';
import { Box, Button, Drawer, IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import HideIcon from '@material-ui/icons/FullscreenExit';
import { FlexBox } from '../../global/FlexBox';
import { Confirm } from './Confirm';

interface UsersDrawerProps {
  isOpen: boolean;
  handleDrawerClose: () => void;
  children: React.ReactNode;
  hasHide?: boolean;
  title?: string;
  confirmOnClose?: boolean;
  confirmTitle?: string;
  confirmContent?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  id: string;
  initialData?: any;
  handleHide?: () => void;
}

export default function UsersDrawer({
  isOpen,
  handleDrawerClose,
  children,
  hasHide,
  title,
  confirmOnClose = false,
  confirmTitle = 'Are you sure you want to close?',
  confirmContent = 'Any unsaved changes will be lost.',
  confirmButtonText = 'Close',
  cancelButtonText = 'Cancel',
  id,
  handleHide,
  ...restProps
}: UsersDrawerProps) {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const handleClose = () => {
    if (confirmOnClose) {
      setIsConfirmOpen(true);
    } else {
      handleDrawerClose();
    }
  };

  const handleMinimize = () => {
    handleHide?.();
    handleDrawerClose();
  };

  return (
    <>
      <Drawer
        {...restProps}
        open={isOpen}
        anchor="right"
        PaperProps={{
          style: {
            borderRadius: '16px 0 0 16px',
            borderColor: '#E1E4E8',
            width: '816px',
            padding: '40px',
          },
        }}
      >
        <Box
          display="flex"
          justifyContent={hasHide ? 'space-between' : 'flex-end'}
        >
          {hasHide && (
            <Button
              type="button"
              startIcon={<HideIcon color="primary" />}
              variant="text"
              color="primary"
              onClick={handleMinimize}
            >
              Hide
            </Button>
          )}
          <IconButton type="button" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        {title && (
          <>
            <Box mb={3} mt={3}>
              <Typography variant="h3">{title}</Typography>
            </Box>
            <FlexBox mb={6} sx={{ justifyContent: 'space-between' }}>
              <Typography variant="h6">Contact Information</Typography>
              <Typography variant="subtitle1">
                *denotes required field
              </Typography>
            </FlexBox>
          </>
        )}
        <Box>{children}</Box>
      </Drawer>
      {confirmOnClose && (
        <Confirm
          isOpen={isConfirmOpen}
          title={confirmTitle}
          content={confirmContent}
          confirm={confirmButtonText}
          cancel={cancelButtonText}
          onConfirm={() => {
            setIsConfirmOpen(false);
            handleDrawerClose();
          }}
          onClose={() => setIsConfirmOpen(false)}
        />
      )}
    </>
  );
}
